export const THEME_KEY = 'wplanner_theme';

export const themes = {
  light: {
    mode: 'light',
    name: 'Light',
    bg: '#f7fbff',
    bgImage: 'linear-gradient(135deg, rgba(255,255,255,0.92), rgba(232,246,255,0.70) 38%, rgba(255,242,228,0.74)), radial-gradient(circle at 8% 18%, rgba(249,115,22,0.24), transparent 28%), radial-gradient(circle at 80% 8%, rgba(14,165,233,0.24), transparent 30%), radial-gradient(circle at 48% 88%, rgba(124,58,237,0.20), transparent 34%)',
    surface: 'rgba(255,255,255,0.74)',
    surfaceSoft: 'rgba(255,255,255,0.86)',
    surfaceLift: 'rgba(238,249,255,0.82)',
    taskSurface: 'rgba(255,255,255,0.94)',
    glass: 'rgba(255,255,255,0.62)',
    glassStrong: 'rgba(255,255,255,0.78)',
    glassBlur: 'blur(22px) saturate(150%)',
    text: '#162033',
    muted: '#607089',
    faint: '#9aa8bb',
    border: '#fdba74',
    borderSoft: 'rgba(148,163,184,0.32)',
    primary: '#7c3aed',
    primaryDark: '#5b21b6',
    primarySoft: '#f0eaff',
    secondary: '#0284c7',
    secondarySoft: '#e0f7ff',
    accent: '#f97316',
    accentSoft: '#fff0df',
    success: '#16a34a',
    successSoft: '#dcfce7',
    danger: '#dc2626',
    dangerSoft: '#fee2e2',
    shadow: '0 18px 46px rgba(36,55,99,0.14), inset 0 1px 0 rgba(255,255,255,0.64)',
    shadowStrong: '0 30px 90px rgba(36,55,99,0.24), inset 0 1px 0 rgba(255,255,255,0.72)',
    overlay: 'rgba(15,23,42,0.28)',
  },
  dark: {
    mode: 'dark',
    name: 'Dark',
    bg: '#0d1021',
    bgImage: 'linear-gradient(135deg, rgba(13,16,33,0.98), rgba(8,28,48,0.84) 46%, rgba(50,18,52,0.78)), radial-gradient(circle at 14% 8%, rgba(192,132,252,0.34), transparent 28%), radial-gradient(circle at 88% 10%, rgba(34,211,238,0.24), transparent 30%), radial-gradient(circle at 48% 95%, rgba(251,146,60,0.22), transparent 34%)',
    surface: 'rgba(24,27,49,0.72)',
    surfaceSoft: 'rgba(25,29,54,0.84)',
    surfaceLift: 'rgba(16,26,43,0.84)',
    taskSurface: 'rgba(17,22,41,0.92)',
    glass: 'rgba(24,27,49,0.58)',
    glassStrong: 'rgba(24,27,49,0.78)',
    glassBlur: 'blur(22px) saturate(145%)',
    text: '#f7fbff',
    muted: '#c4d0df',
    faint: '#8b9bb0',
    border: '#42526f',
    borderSoft: 'rgba(139,155,176,0.26)',
    primary: '#b879ff',
    primaryDark: '#a855f7',
    primarySoft: 'rgba(192,132,252,0.18)',
    secondary: '#22d3ee',
    secondarySoft: 'rgba(34,211,238,0.14)',
    accent: '#fb923c',
    accentSoft: 'rgba(251,146,60,0.16)',
    success: '#4ade80',
    successSoft: 'rgba(74,222,128,0.14)',
    danger: '#fb7185',
    dangerSoft: 'rgba(251,113,133,0.14)',
    shadow: '0 20px 55px rgba(0,0,0,0.34), inset 0 1px 0 rgba(255,255,255,0.06)',
    shadowStrong: '0 34px 100px rgba(0,0,0,0.56), inset 0 1px 0 rgba(255,255,255,0.08)',
    overlay: 'rgba(2,6,23,0.68)',
  },
};

export function getStoredTheme() {
  if (typeof window === 'undefined') return 'light';
  const stored = window.localStorage.getItem(THEME_KEY);
  return stored === 'dark' ? 'dark' : 'light';
}
